module.exports = __webpack_public_path__ + "static/tattoo4-ef49d519445c52524a6de3b167c94d48.jpg";